import cn from 'classnames';

export interface NewsCardProps extends React.HTMLAttributes<HTMLDivElement> {}

const NewsCard: React.FC<NewsCardProps> = ({ className, children }) => (
  <section className={cn('news-section', className)}>{children}</section>
);

export default NewsCard;
